import type { Dispatch } from 'react';

import { FakeTopBar } from './FakeTopBar';
import { FormStep } from './FormStep';
import { useDraftStepProgress } from './hooks/useDraftStepProgress';
import { PayoutDraftPreview } from './PayoutDraftPreview';
import { ReviewDraft } from './ReviewDraft';
import { Stepper } from './Stepper';
import { formatStepTitle } from './utils/formatters';
import type { SubmittedPayout } from './utils/types';

type CreateManualPayoutFlowProps = {
  onSubmitted: Dispatch<SubmittedPayout | undefined>;
};

export const CreateManualPayoutFlow = ({
  onSubmitted
}: CreateManualPayoutFlowProps) => {
  const { currentStep, isFinalStep } = useDraftStepProgress();

  return (
    <>
      <Stepper className="col-span-4" />
      {isFinalStep ? (
        <div className="z-10 flex grow justify-center">
          <ReviewDraft onSubmitted={onSubmitted} />
        </div>
      ) : (
        <div className="z-10 grid grow grid-cols-7 gap-10">
          <div className="col-span-4 flex h-fit flex-col justify-between gap-4 rounded-2xl border bg-white p-8 shadow-md">
            <div
              className="pt-1 text-lg font-semibold"
              data-testid="manual-payout-step-title"
            >
              {formatStepTitle(currentStep)}
            </div>
            <FormStep key={currentStep} />
          </div>
          <div className="col-span-3 h-full overflow-hidden rounded-2xl bg-white shadow-md">
            <FakeTopBar height={12} />
            <h1 className="py-2 pl-6 text-lg font-semibold">Summary</h1>
            <PayoutDraftPreview />
          </div>
        </div>
      )}
    </>
  );
};
